import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getEmailDomainSearch } from "../../../services/instutionscustomersService";
import { createUser, checkEmailExists } from "../../../services/userService";
import { logo } from "../../imagepath";

const Register = () => {
  const [step, setStep] = useState(1);
  const [inst, setInst] = useState(null);
  
  // 1. GÜNCELLEME: kvkk default 1 (seçili) olarak başlatıldı
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    surname: "",
    password: "",
    confirmPassword: "",
    telephone: "",
    address: "",
    tc: "",
    accesip: [],
    instId: '',
    accessdeniedip: [],
    kvkk: 1, 
  });
  
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);

  // 2. GÜNCELLEME: Checkbox ise 1 veya 0 ata, değilse değeri al
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      // Eğer tip checkbox ise: true ise 1, false ise 0 yap. Değilse normal value'yu al.
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (isCheckingEmail) return;
    setIsCheckingEmail(true);
    setError(null);

    try {
      await checkEmailExists(formData.email);
      let domainSearchResponse;
      try {
        domainSearchResponse = await getEmailDomainSearch(formData.email, 1);
        setInst(domainSearchResponse.data);
      } catch (domainError) {
        console.warn("Kurum bulunamadı, kayıt sürecine devam ediliyor.");
        setInst(null);
      }

      if (domainSearchResponse && domainSearchResponse.data && domainSearchResponse.data.length > 0) {
        setStep(3);
      } else {
        setStep(2);
      }
      setSuccess(null);
    } catch (emailCheckError) {
      setError(emailCheckError.message || "E-posta doğrulama sırasında bir hata oluştu.");
      setStep(1);
      if (emailCheckError.response && emailCheckError.response.data && emailCheckError.response.data.message) {
        setError(emailCheckError.response.data.message);
      }
    } finally {
      setIsCheckingEmail(false);
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    if (isRegistering) return;

    if (formData.password !== formData.confirmPassword) {
      setError("Şifreler uyuşmuyor. Lütfen tekrar deneyin.");
      return;
    }

    setIsRegistering(true);
    setError(null);

    try {
      // formData.kvkk zaten handleChange sayesinde 1 veya 0 olduğu için direkt gönderiyoruz.
      const response = await createUser(formData, formData.instId);
      if (response.data) {
        setSuccess(response.message || "Kayıt başarıyla oluşturuldu.");
        setError(null);
      } else {
        setError(response.message || "Kayıt oluşturulamadı.");
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Kayıt oluşturulurken bir hata oluştu.";
      setError(msg);
    } finally {
      setIsRegistering(false);
    }
  };


  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="flex-grow-1">
        <div className="container-fluid">
          <div className="row min-vh-100 justify-content-center align-items-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
              {/* Logo kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                <Link to="/home">
                  <img src={logo} className="img-fluid" alt="Logo" style={{ maxHeight: 50 }} />
                </Link>
              </div>
              {/* Form kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-4">
                <h4 className="fw-semibold mb-2 text-center text-darkfume ">Kayıt Ol</h4>
                <hr className="mb-4 mt-0" />
                
                {/* 1. Adım */}
                {step === 1 && (
                  <form onSubmit={handleEmailSubmit}>
                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">E-posta</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="E-posta"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className="d-grid">
                      <button className="btn text-sm btn-primary" type="submit">
                        Devam Et
                      </button>
                    </div>
                  </form>
                )}

                {/* 2. Adım */}
                {step === 2 && (
                  <form onSubmit={handleRegisterSubmit}>
                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">İsim</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="İsim"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        autoComplete="given-name"
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">Soyisim</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Soyisim"
                        name="surname"
                        value={formData.surname}
                        onChange={handleChange}
                        required
                        autoComplete="no"
                      />
                    </div>

                    <input
                      type="text"
                      style={{ display: 'none' }}
                      autoComplete="username"
                    />

                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">Şifre</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Şifre"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                      />
                    </div>

                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">Şifre Tekrar</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Şifre Tekrar"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                      />
                    </div>

                    {/* KVKK Metni ve Pazarlama Checkbox */}
                    <div className="mb-3">
                      
                      {/* KVKK Metni */}
                      <p className="text-secondary text-sm mb-2">
                        Hesap oluşturarak <a href="https://idealonline.com.tr/kvkk" target="_blank" rel="noopener noreferrer" className="text-blue text-decoration-none fw-medium">Aydınlatma Metni ve Gizlilik Politikasını</a> okuyup onayladığınızı kabul ediyorsunuz.
                      </p>

                      {/* Pazarlama Checkbox */}
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="kvkk"
                          id="kvkkCheck"
                          // 3. GÜNCELLEME: State 1 ise checked true olsun
                          checked={formData.kvkk === 1}
                          onChange={handleChange}
                        />
                        <label className="form-check-label text-secondary text-sm" htmlFor="kvkkCheck" style={{ fontSize: "0.85rem" }}>
                          Kampanya, tanıtım ve bilgilendirme e-postaları almak istiyorum.
                        </label>
                      </div>

                    </div>

                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {success && <p style={{ color: "green" }}>{success}</p>}
                    <div className="d-grid">
                      <button
                        className="btn text-sm btn-primary"
                        type="submit"
                        disabled={isRegistering}
                      >
                        {isRegistering ? "Kayıt Oluşturuluyor..." : "Kayıt Ol"}
                      </button>
                    </div>
                  </form>
                )}

                {/* 3. Adım: Kurum seçimi */}
                {step === 3 && (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (formData.instId) {
                        setStep(2);
                      } else {
                        setError("Lütfen bir kurum seçin.");
                      }
                    }}
                  >
                    <div className="input-block">
                      <label className="form-control-label fw-bold text-darkfume text-sm mb-3">
                        Lütfen kurumunuzu seçin:
                      </label>

                      {inst && inst.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                          {inst.map((institution) => {
                            const isSelected = formData.instId === institution.id;
                            const photoUrl = institution.photo
                              ? `https://idealonline.com.tr/service/idealonline/v1/instutionscustomers/displayFile/${institution.id}/${institution.photo}`
                              : null;

                            const domainText =
                              institution.domain && institution.domain.length > 0
                                ? institution.domain[0]
                                : "";

                            return (
                              <div
                                key={institution.id}
                                onClick={() =>
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    instId: institution.id,
                                  }))
                                }
                                className={`position-relative p-3 rounded-3 border shadow-sm d-flex align-items-center justify-content-between gap-3 institution-card ${isSelected ? "selected border-primary-green shadow" : "hoverable"
                                  }`}
                                style={{
                                  cursor: "pointer",
                                  transition: "all 0.2s ease-in-out",
                                }}
                              >
                                <div
                                  className={`position-absolute top-0 start-0 translate-middle rounded-circle d-flex align-items-center justify-content-center`}
                                  style={{
                                    width: 22,
                                    height: 22,
                                    backgroundColor: isSelected ? "#0071ceff" : "#a7a7a7ff",
                                    color: "white",
                                  }}
                                >
                                  {isSelected && <i className="fa fa-check text-sm" />}
                                </div>

                                {photoUrl && (
                                  <div
                                    className="flex-shrink-0"
                                    style={{
                                      width: 50,
                                      height: 50,
                                      overflow: "hidden",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <img
                                      src={photoUrl}
                                      alt={institution.name}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                )}

                                <div className="flex-grow-1">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="mb-1 text-darkfume fw-semibold">{institution.name}</h6>
                                    {domainText && <small className="text-secondary">{domainText}</small>}
                                  </div>
                                  <small className="text-secondary">{institution.sortname}</small>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <p>Hiçbir kurum bulunamadı.</p>
                      )}
                    </div>

                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className="d-grid mt-3">
                      <button
                        className="btn text-sm btn-primary"
                        type="submit"
                        disabled={isCheckingEmail}
                      >
                        Devam Et
                      </button>
                    </div>
                  </form>
                )}

                <div className="text-sm text-center mt-4">
                  <p className="mb-0">
                    <span className="me-2 text-darkfume">Zaten hesabınız var mı?</span>
                    <Link className="text-blue" to="/login">Giriş Yap</Link>
                  </p>
                </div>
              </div>
            </div>
            <footer className="w-100 text-center mt-auto mb-2">
              <small className="text-secondary">
                © 2025 Ideal Online &middot;
                <Link to="/kvkk" className="text-secondary text-decoration-none mx-1">KVKK</Link> &middot;
                <Link to="/help" className="text-secondary text-decoration-none mx-1">Yardım</Link>
              </small>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;